/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetModelResponse
 */
export interface AssetModelResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetModelResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetModelResponse
     */
    manufacturerId?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetModelResponse
     */
    assetTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetModelResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetModelResponse
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetModelResponse
     */
    bushedShoesAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetModelResponse
     */
    hasTumblerRollPathMeasurement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetModelResponse
     */
    showFrontIdlerConditionMenu?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetModelResponse
     */
    showLoadRollerConditionMenu?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetModelResponse
     */
    showRearIdlerConditionMenu?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetModelResponse
     */
    showReturnRollerConditionMenu?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetModelResponse
     */
    showSliderConditionMenu?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssetModelResponse
     */
    shoesPerSide?: number | null;
}

/**
 * Check if a given object implements the AssetModelResponse interface.
 */
export function instanceOfAssetModelResponse(value: object): value is AssetModelResponse {
    return true;
}

export function AssetModelResponseFromJSON(json: any): AssetModelResponse {
    return AssetModelResponseFromJSONTyped(json, false);
}

export function AssetModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'assetTypeId': json['assetTypeId'] == null ? undefined : json['assetTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'bushedShoesAvailable': json['bushedShoesAvailable'] == null ? undefined : json['bushedShoesAvailable'],
        'hasTumblerRollPathMeasurement': json['hasTumblerRollPathMeasurement'] == null ? undefined : json['hasTumblerRollPathMeasurement'],
        'showFrontIdlerConditionMenu': json['showFrontIdlerConditionMenu'] == null ? undefined : json['showFrontIdlerConditionMenu'],
        'showLoadRollerConditionMenu': json['showLoadRollerConditionMenu'] == null ? undefined : json['showLoadRollerConditionMenu'],
        'showRearIdlerConditionMenu': json['showRearIdlerConditionMenu'] == null ? undefined : json['showRearIdlerConditionMenu'],
        'showReturnRollerConditionMenu': json['showReturnRollerConditionMenu'] == null ? undefined : json['showReturnRollerConditionMenu'],
        'showSliderConditionMenu': json['showSliderConditionMenu'] == null ? undefined : json['showSliderConditionMenu'],
        'shoesPerSide': json['shoesPerSide'] == null ? undefined : json['shoesPerSide'],
    };
}

export function AssetModelResponseToJSON(json: any): AssetModelResponse {
    return AssetModelResponseToJSONTyped(json, false);
}

export function AssetModelResponseToJSONTyped(value?: AssetModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'manufacturerId': value['manufacturerId'],
        'assetTypeId': value['assetTypeId'],
        'name': value['name'],
        'description': value['description'],
        'bushedShoesAvailable': value['bushedShoesAvailable'],
        'hasTumblerRollPathMeasurement': value['hasTumblerRollPathMeasurement'],
        'showFrontIdlerConditionMenu': value['showFrontIdlerConditionMenu'],
        'showLoadRollerConditionMenu': value['showLoadRollerConditionMenu'],
        'showRearIdlerConditionMenu': value['showRearIdlerConditionMenu'],
        'showReturnRollerConditionMenu': value['showReturnRollerConditionMenu'],
        'showSliderConditionMenu': value['showSliderConditionMenu'],
        'shoesPerSide': value['shoesPerSide'],
    };
}

